const formatPriceInUsd = (price: number) => `$${price.toFixed(2)}`;

export default formatPriceInUsd;
